import { Box, BoxProps, Container } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export interface PageBodyProps extends BoxProps {}

export const PageBody = (props: PropsWithChildren<PageBodyProps>) => {
  const { children, ...other } = props;

  return (
    <Box
      as="section"
      bg="bg-surface"
      pt={{ base: '4', md: '8' }}
      pb={{ base: '4', md: '8' }}
      borderRadius={'lg'}
      boxShadow={'2xl'}
      {...other}
    >
      <Container minWidth={'100%'}>{children}</Container>
    </Box>
  );
};
